import { createForm } from 'shared-ui/lib/customs/form/FormGenerator';
import { FormInput } from 'shared-ui/lib/customs/form/FormInput';
import { adminOptionsInput } from '../inputs/admin-options.input';

const form: FormInput[] = [adminOptionsInput.archiveUser, adminOptionsInput.stripePriceId];

export const adminOptionsForm = createForm(form);

export type AdminOptionsFormBody = {
  archiveUser: string;
  stripePriceId: string;
};
